import { ChevronLeftIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import EditCityPageSections from "../../components/city-pages/edit/EditSections";
import EditCityPageStatistics from "../../components/city-pages/edit/EditStatistics";
import EditCityPageFAQ from "../../components/city-pages/edit/EditFAQ";
import EditCityPageSEO from "../../components/city-pages/edit/EditSEO";
import { getCityPageById } from "../../services/CityPages.service";

const EditCityPage = () => {
  const { id, tab = "sections" } = useParams<{ id: string; tab?: string }>();
  const navigate = useNavigate();
  const [cityPage, setCityPage] = useState<{
    cityName: string;
    countryName: string;
  } | null>(null);

  const handleTabChange = (
    newTab: "sections" | "statistics" | "faq" | "seo"
  ) => {
    navigate(`/city-pages/edit/${id}/${newTab}`);
  };

  useEffect(() => {
    const fetchCityPage = async () => {
      if (id) {
        const response = await getCityPageById(id);
        setCityPage(response.data);
      }
    };
    fetchCityPage().catch(console.error);
  }, [id]);

  return (
    <div>
      <Link
        to="/city-pages"
        className="flex items-center mb-4 text-sm font-semibold text-primary"
      >
        <ChevronLeftIcon className="w-4 h-4 mr-2" />
        Kthehu tek qytetet
      </Link>
      <div className="border rounded-lg p-6">
        <h1 className="text-xl mb-2">
          {`Modifiko faqen e qytetit: ${cityPage?.cityName ?? ""} (${cityPage?.countryName ?? ""})`}
        </h1>
        <div className="flex gap-4 mb-3 w-full border-b">
          {([
            { key: "sections", label: "Seksionet" },
            { key: "statistics", label: "Statistikat" },
            { key: "faq", label: "FAQ" },
            { key: "seo", label: "SEO" }
          ] as const).map((t) => (
            <button
              key={t.key}
              type="button"
              className={`text-sm py-2 px-1 transition-colors ${
                tab === t.key
                  ? "border-b-2 border-b-primary text-primary font-semibold"
                  : "text-gray-500 hover:text-gray-700"
              }`}
              onClick={() => handleTabChange(t.key)}
            >
              {t.label}
            </button>
          ))}
        </div>
        <div>
          {tab === "sections" && <EditCityPageSections />}
          {tab === "statistics" && <EditCityPageStatistics />}
          {tab === "faq" && <EditCityPageFAQ />}
          {tab === "seo" && <EditCityPageSEO />}
        </div>
      </div>
    </div>
  );
};

export default EditCityPage;
